import { PureComponent, MouseEvent } from 'react';

import { injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';

import Button from '@atlaskit/button/standard-button';
import { ButtonProps } from '@atlaskit/button/types';
import CopyIcon from '@atlaskit/icon/core/copy';
import Tooltip, { PositionType } from '@atlaskit/tooltip';

import messages from '../i18n';
import * as styles from '../styles';
import copy from '../utils/clipboard-copy';

type CopyButtonProps = ButtonProps & {
  intl: IntlShape;
  shouldMatchTextFieldHeight?: boolean;
  tooltipContent?: string;
  tooltipPosition?: PositionType;
  value?: string;
  ariaLabelOverride?: string;
};

type CopyButtonState = {
  textIsCopied: boolean;
};

class CopyButton extends PureComponent<CopyButtonProps, CopyButtonState> {
  state = {
    textIsCopied: false,
  };

  handleClick = (e: MouseEvent<HTMLElement>) => {
    copy(this.props.value || '');

    this.setState({ textIsCopied: true });

    if (this.props.onClick) {
      // @ts-ignore we don't have an analytics event to pass here nor want to
      this.props.onClick(e);
    }
  };

  render() {
    const {
      intl,
      shouldMatchTextFieldHeight = true,
      tooltipContent,
      tooltipPosition = 'right',
      value,
      ariaLabelOverride,
      ...buttonProps
    } = this.props;

    const mainButton = (
      <Tooltip
        content={
          this.state.textIsCopied
            ? intl.formatMessage(messages.buttonClickedTooltip)
            : tooltipContent || intl.formatMessage(messages.buttonTooltip)
        }
        position={tooltipPosition}
        onShow={() => this.setState({ textIsCopied: false })}
        testId="copy-button-tooltip"
      >
        <Button
          {...(buttonProps as ButtonProps)}
          aria-label={
            ariaLabelOverride || intl.formatMessage(messages.buttonLabel)
          }
          type="button"
          onClick={this.handleClick}
          iconBefore={<CopyIcon spacing="spacious" label="" />}
        />
      </Tooltip>
    );
    return shouldMatchTextFieldHeight ? (
      <styles.CopyButtonToMatchTextfield>
        {mainButton}
      </styles.CopyButtonToMatchTextfield>
    ) : (
      mainButton
    );
  }
}

// eslint-disable-next-line import/no-default-export
export default injectIntl(CopyButton);
